import { Hostname } from 'constants/hostnames'; // All of the groups will always exist on
// `OptanonConsent` cookie. If the group is
// enabled or not is defined by the binary
// value after the `:`.
//
// For example, `C0001:1` means that
// stricly necessary cookies group is
// enabled and respectively `C0001:0`
// means that it is disabled
//
// Therefore, we don't need to work with
// values to check if `C0001:0` exists.
// Getting a result that `C0001:1` does
// not exist would have the same outcome.

export let ConsentGroup;

(function (ConsentGroup) {
  ConsentGroup["StrictlyNecessary"] = "C0001:1";
  ConsentGroup["Performance"] = "C0002:1";
  ConsentGroup["Functional"] = "C0003:1";
  ConsentGroup["Targeting"] = "C0004:1";
  ConsentGroup["SocialMedia"] = "C0005:1";
  ConsentGroup["AmazonAdvertising"] = "C0015:1";
  ConsentGroup["PersonalisedAds"] = "V2STACK42:1";
  ConsentGroup["NonIAB"] = "M0001:1";
  ConsentGroup["Google"] = "gad:1";
})(ConsentGroup || (ConsentGroup = {}));

export let CookieConsentVersion; // Make sure that then adding/changing these keys it's also changed in
// https://github.com/vinted/core/blob/master/config/constants/consent/consent.rb

(function (CookieConsentVersion) {
  CookieConsentVersion["Europe"] = "eu";
  CookieConsentVersion["California"] = "us-ca";
  CookieConsentVersion["None"] = "none";
})(CookieConsentVersion || (CookieConsentVersion = {}));

export const consentKeyByHostname = {
  [Hostname.At]: '7cee258e-a707-4de7-bcfd-23a314589dec',
  [Hostname.AtSandbox]: '7cee258e-a707-4de7-bcfd-23a314589dec-test',
  [Hostname.Be]: '330b7cd6-c85d-481b-9d45-c373b76dfba6',
  [Hostname.BeSandbox]: '330b7cd6-c85d-481b-9d45-c373b76dfba6-test',
  [Hostname.Cz]: '504deae3-0dd0-4d2d-97bb-a1281a3ef754',
  [Hostname.CzSandbox]: '504deae3-0dd0-4d2d-97bb-a1281a3ef754-test',
  [Hostname.OldCz]: '504deae3-0dd0-4d2d-97bb-a1281a3ef754',
  [Hostname.OldCzSandbox]: '504deae3-0dd0-4d2d-97bb-a1281a3ef754-test',
  [Hostname.De]: '77cefc92-e89f-48f9-8ae1-23dcee412e05',
  [Hostname.DeSandbox]: '77cefc92-e89f-48f9-8ae1-23dcee412e05-test',
  [Hostname.Dk]: 'bbd4ef29-6ff5-4251-8cdb-0b09154e7190',
  [Hostname.DkSandbox]: 'bbd4ef29-6ff5-4251-8cdb-0b09154e7190-test',
  [Hostname.OldDe]: '74186047-0da8-47be-859b-f8e9a90eb2bf',
  [Hostname.OldDeBabies]: '6bd97a65-ee45-43e8-a1c4-93635f816dce',
  [Hostname.OldDeBabiesSandbox]: '6bd97a65-ee45-43e8-a1c4-93635f816dce-test',
  [Hostname.Es]: '1d000587-cd97-47a0-a153-ae5e95d7bcd0',
  [Hostname.EsSandbox]: '1d000587-cd97-47a0-a153-ae5e95d7bcd0-test',
  [Hostname.OldEs]: '1d000587-cd97-47a0-a153-ae5e95d7bcd0',
  [Hostname.OldEsSandbox]: '1d000587-cd97-47a0-a153-ae5e95d7bcd0-test',
  [Hostname.Fr]: '1faba56f-ca85-4225-be79-f1b66164759d',
  [Hostname.FrSandbox]: '1faba56f-ca85-4225-be79-f1b66164759d-test',
  [Hostname.Hu]: 'a9c3a318-16a9-4b1a-9119-f5138d264acc',
  [Hostname.HuSandbox]: 'a9c3a318-16a9-4b1a-9119-f5138d264acc-test',
  [Hostname.Lt]: '9ff8d790-f9a3-4339-93b8-35166410f9a8',
  [Hostname.LtSandbox]: '9ff8d790-f9a3-4339-93b8-35166410f9a8-test',
  [Hostname.Lu]: '2caade4a-9608-45dd-8d3d-3c57e3f10d65',
  [Hostname.LuSandbox]: '2caade4a-9608-45dd-8d3d-3c57e3f10d65-test',
  [Hostname.Nl]: '6d189325-d5c7-4ad1-b313-04bdd1b4cfd5',
  [Hostname.NlSandbox]: '6d189325-d5c7-4ad1-b313-04bdd1b4cfd5-test',
  [Hostname.OldNl]: '6d189325-d5c7-4ad1-b313-04bdd1b4cfd5',
  [Hostname.OldNlSandbox]: '6d189325-d5c7-4ad1-b313-04bdd1b4cfd5-test',
  [Hostname.Pl]: '1e3b4268-d6b8-4743-b5ec-fc6fa398ed27',
  [Hostname.PlSandbox]: '1e3b4268-d6b8-4743-b5ec-fc6fa398ed27-test',
  [Hostname.OldPl]: '1e3b4268-d6b8-4743-b5ec-fc6fa398ed27',
  [Hostname.OldPlSandbox]: '6d189325-d5c7-4ad1-b313-04bdd1b4cfd5-test',
  [Hostname.Se]: '15351e80-18f5-42a5-94a3-a129323b3fad',
  [Hostname.SeSandbox]: '15351e80-18f5-42a5-94a3-a129323b3fad-test',
  [Hostname.Sk]: '10f633e1-04dd-4dae-81fa-a863c40a9e04',
  [Hostname.SkSandbox]: '10f633e1-04dd-4dae-81fa-a863c40a9e04-test',
  [Hostname.Pt]: '5a16f27d-fc15-4288-89cc-b4bfd125b5b1',
  [Hostname.PtSandbox]: '5a16f27d-fc15-4288-89cc-b4bfd125b5b1-test',
  [Hostname.Uk]: '7c1e0f13-a29f-4cba-9aad-f1d1be84c4e3',
  [Hostname.UkSandbox]: '7c1e0f13-a29f-4cba-9aad-f1d1be84c4e3-test',
  [Hostname.OldUk]: '7c1e0f13-a29f-4cba-9aad-f1d1be84c4e3',
  [Hostname.OldUkSandbox]: '7c1e0f13-a29f-4cba-9aad-f1d1be84c4e3-test',
  [Hostname.Us]: '00a8b98f-e69a-41a8-b4d8-e7118a39a23a',
  [Hostname.UsSandbox]: '00a8b98f-e69a-41a8-b4d8-e7118a39a23a-test',
  [Hostname.OldUs]: '00a8b98f-e69a-41a8-b4d8-e7118a39a23a',
  [Hostname.OldUsSandbox]: '00a8b98f-e69a-41a8-b4d8-e7118a39a23a-test',
  [Hostname.It]: '1b74cfac-ad4f-47c1-a3c9-d71707ac085c',
  [Hostname.ItSandbox]: '1b74cfac-ad4f-47c1-a3c9-d71707ac085c-test',
  [Hostname.Ro]: 'ed81fa23-b427-45c9-ada3-c9e1d3c09fe0',
  [Hostname.RoSandbox]: 'ed81fa23-b427-45c9-ada3-c9e1d3c09fe0-test',
  [Hostname.Fi]: 'b1984a2c-9666-4748-8699-63180f09f606',
  [Hostname.FiSandbox]: 'b1984a2c-9666-4748-8699-63180f09f606-test'
};